import { render, staticRenderFns } from "./PickHighlightModel.vue?vue&type=template&id=49670897&scoped=true"
import script from "./PickHighlightModel.vue?vue&type=script&lang=js"
export * from "./PickHighlightModel.vue?vue&type=script&lang=js"
import style0 from "./PickHighlightModel.vue?vue&type=style&index=0&id=49670897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49670897",
  null
  
)

export default component.exports